import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import TripCardHelp from '../../TripCardHelp';
import { Message } from '../styles';
import { XCircleIcon } from './styles';

const Expired = () => {
  const { t } = useStoreTranslation();

  return (
    <TripCardHelp icon={<XCircleIcon />} withContactButtons title={t('customerSupport.expired.title')}>
      <Message>{t('customerSupport.expired.message')}</Message>
    </TripCardHelp>
  );
};

export default Expired;
